// Keep in sync with apps/backoffice-webapp/src/hooks/use-country-options.ts or move to a shared package
import { countries } from 'countries-list';
import { useMemo } from 'react';

export const useCountryOptions = () => {
	return useMemo(
		() =>
			Object.entries(countries).map(([code, country]) => ({
				code,
				name: country.name,
			})),
		[],
	);
};
